<template>
  <section class="dashboard-card-deck">
    <dashboard-card
      v-for="(card, index) in visibleCards"
      :key="`dashboard-card-${index}`"
      :card="card"
      :index="index + 1"
    />
    <DashboardNeedHelp />
  </section>
</template>

<script>
  import DashboardNeedHelp from './DashboardNeedHelp.vue';

  export default {
    name: 'DashBoardCardDeck',
    components: { DashboardNeedHelp },
    props: {
      user: {
        type: Object,
        required: true,
      },
      myData: Boolean,
      webinars: Boolean,
    },
    data: () => ({
      cards: [
        {
          title: 'My Info',
          image: {
            src: '/images/dashboard/dashboard_my_info.webp',
            alt: 'My Info',
          },
          route: '/dashboard/user',
        },
        {
          title: 'Billing Info',
          image: {
            src: '/images/dashboard/dashboard_billing_info.webp',
            alt: 'Billing Info',
          },
          route: '/dashboard/billing',
        },
        {
          title: 'My Data',
          image: {
            src: '/images/dashboard/dashboard_my_data.webp',
            alt: 'My Data',
          },
          route: '/dashboard/datasets',
        },
        {
          title: 'Manage Users & Permissions',
          image: {
            src: '/images/dashboard/dashboard_manage_users_teams.webp',
            alt: 'Manage Users & Permissions',
          },
          route: '/dashboard/manage-users-and-permissions',
        },
        {
          title: 'My Subscriptions',
          image: {
            src: '/images/dashboard/dashboard_manage_subscriptions.webp',
            alt: 'My Subscriptions',
          },
          route: '/dashboard/subscriptions',
        },
        {
          title: 'Webinars',
          image: {
            src: '/images/dashboard/dashboard_webinars.webp',
            alt: 'Webinars',
          },
          route: '/dashboard/webinars',
        },
      ],
      disabled: [],
      adminOnly: ['Manage Users & Permissions'],
    }),
    computed: {
      userIsAdmin() {
        return !!this.user.company_administrator;
      },
      visibleCards() {
        return this.cards.filter((card) => {
          if (this.disabled.includes(card.title)) return false;
          if (!this.userIsAdmin && this.adminOnly.includes(card.title))
            return false;
          if (card.title === 'My Data' && !this.myData) return false;
          if (!this.webinars && card.title === 'Webinars') return false;
          return true;
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .dashboard-card-deck {
    display: flex;
    flex-wrap: wrap;
    gap: 3vw;

    width: 100%;
  }
  .dashboard-card-deck > :deep(.dashboard-card),
  .dashboard-card-deck > :deep(.dashboard-need-help) {
    width: 100%;

    @media screen and (min-width: 768px) {
      width: calc(50% - 3vw);
    }

    @media screen and (min-width: 992px) {
      width: calc(33.33% - 3vw);
    }

    @media screen and (min-width: 1400px) {
      width: calc(25% - 3vw);
    }
  }
</style>
